module.exports = __webpack_public_path__ + "static/women-who-work-c2471116226015b98a0d7d582017e712.jpg";